import React from 'react';

/** Score line: (score) 👜 (bag count) bags */
function ScoreBagsDisplay({ score, bags, className = '' }) {
  return (
    <span className={['spades-score-bags-line', className].filter(Boolean).join(' ')}>
      <span className="spades-score-value">{score ?? 0}</span>
      <span className="spades-score-bag-sep" aria-hidden>👜</span>
      <span className="spades-score-bag-count">{bags ?? 0}</span>
      <span className="spades-score-bag-label">bags</span>
    </span>
  );
}

export default ScoreBagsDisplay;